import React, { PropsWithChildren, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { breakPoint } from '../theme';
import { Drawer } from '../../core/stores/drawer';
import { uiStore } from '../../core/stores/ui-store';

export const ContextualDrawer: React.FC<PropsWithChildren> = observer(({ children }) => {
  useEffect(() => {
    uiStore.contextDrawer = new Drawer();

    return () => {
      uiStore.contextDrawer = undefined;
    };
  }, []);

  return <Container data-is-closed={!uiStore.contextDrawer?.isOpen}>{children}</Container>;
});

const Container = styled.div`
  position: absolute;
  overflow: auto;
  display: flex;
  flex-direction: column;
  z-index: 1002;
  height: 100%;
  width: calc(100% - 5.6rem);
  max-width: 32rem;
  right: 0;
  top: 0;
  background: var(--color-grayscale-shark);
  padding: 2.4rem 1.6rem;
  transition: all 200ms ease-in;
  transform: translateX(0);
  border-left: solid 1px var(--content-border-color);

  &[data-is-closed='true'] {
    transform: translateX(100%);
  }

  @media screen and (min-width: ${breakPoint.medium}px) {
    display: none;
  }
`;
